import { MoonOutlined, SunOutlined } from '@ant-design/icons'
import { Button, Switch } from 'antd'

import { useThemeMode } from '@/hooks/useThemeMode'

export function ThemeSwitcher({ collapsed }: { collapsed?: boolean }) {
  const { isDark, toggleMode } = useThemeMode()

  if (collapsed) {
    return (
      <Button
        type="text"
        icon={isDark ? <MoonOutlined /> : <SunOutlined />}
        onClick={toggleMode}
        style={{ width: '100%' }}
      />
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
      }}
    >
      <SunOutlined style={{ fontSize: 14, opacity: isDark ? 0.45 : 1 }} />
      <Switch checked={isDark} onChange={toggleMode} size="small" />
      <MoonOutlined style={{ fontSize: 14, opacity: isDark ? 1 : 0.45 }} />
    </div>
  )
}
